module.exports = __webpack_public_path__ + "static/media/T14-T25-08.feb37cc2.svg";